import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Loader2 } from 'lucide-react';

/**
 * AuthGuard: Protects routes that require authentication.
 * Shows a loading spinner while auth state initializes.
 * Redirects to /login if no session found.
 *
 * Usage: <AuthGuard><ProtectedComponent /></AuthGuard>
 * For admin: <AuthGuard requireAdmin><AdminComponent /></AuthGuard>
 */
export default function AuthGuard({ children, requireAdmin = false }) {
  const session = useAuthStore(s => s.session);
  const profile = useAuthStore(s => s.profile);
  const loading = useAuthStore(s => s.loading);
  const initialized = useAuthStore(s => s.initialized);

  // Still loading auth state
  if (!initialized || loading) {
    return (
      <div className="min-h-screen bg-page flex items-center justify-center">
        <div className="text-center">
          <Loader2 size={40} className="text-brand animate-spin mx-auto mb-4" />
          <p className="text-ink-3 text-sm font-bold">Wird geladen...</p>
        </div>
      </div>
    );
  }

  // Not logged in
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Admin required but user is not admin
  if (requireAdmin && profile?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
